import {IFormSold} from '../pages/onePolicy/soldTypes'

export const INIT_FORM: IFormSold = {
  policyholder: {
    isApplicant: 'yes',
    firstName: '',
    lastName: '',
    dateBirth: '',
    email: '',
    maritalStatus: '',
    weight: '',
    language: 'Spanish',
    middleName: '',
    secondLastName: '',
    gender: 'Male',
    phone: '',
    countryBirth: '',
    height: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    stateProvince: '',
    zipcode: '',
    country: '',
    mailingAddressLine1: '',
    mailingAddressLine2: '',
    mailingCity: '',
    mailingStateProvince: '',
    mailingZipCode: '',
    mailingCounty: '',
    immigrationStatus: '',
    uscis: '',
    ssn: '',
    greenCard: '',
    workPermitCard: '',
    driverLicense: '',
    immigrationStatusCategory: '',
    passport: '',
    ssnIssuedDate: '',
    greenCardIssueDate: '',
    greenCardExpirationDate: '',
    workPermitIssueDate: '',
    workPermitExpirationDate: '',
    driverLicenseExpirationDate: '',
    medicareNumber: '',
    medicarePartAStartDate: '',
    medicarePartBStartDate: '',
    employerName1: '',
    selfEmployed1: false,
    employerPhone1: '',
    positionOccupation1: '',
    annualIncome1: '',
    employerName2: '',
    selfEmployed2: false,
    employerPhone2: '',
    positionOccupation2: '',
    annualIncome2: '',
    employerName3: '',
    selfEmployed3: false,
    employerPhone3: '',
    positionOccupation3: '',
    annualIncome3: '',
  },
  familyMembers: {
    numberApplicants: '',
    numberMembers: '',
    numberDependents: '',
    familyMember: [],
  },
  insurancePayments: {
    ffmUsedMarketplace: '',
    npnUsedMarketplace: '',
    typeSale: '',
    effectiveDate: '',
    marketplaceID: '',
    memberID: '',
    cmsPlanID: '',
    Carrier: '',
    planName: '',
    metalLevel: '',
    policyTotalCost: '',
    taxCreditSubsidy: '',
    premium: '',
    recurrentPayment: '',
    firstPaymentDate: '',
    preferredPaymentDayEachMonth: '',
    creditDebit: '',
    bankEFT: '',
    cardCompany: '',
    bankName: '',
    paymentMethodHolder: '',
    cardNumber: '',
    abaRouting: '',
    addressLine1: '',
    addressLine2: '',
    expirationMonth: '',
    expirationYear: '',
    accountNumber: '',
    city: '',
    cvvCsv: '',
    stateProvince: '',
    zipCode: '',
  },
  extras: {
    primaryDoctorInformation: '',
    medicinesNeeded: '',
    extraNotesComments: '',
    cancellationDate: '',
    specialEnrollmentDate: '',
    specialEnrollmentReason: '',
  },
}

export const INIT_FORM_ATTACHMENTS = {
  name: '',
  attachments: '',
  comments: '',
  documentTagId: '',
  expirationDate: '',
  memberPolicyId: '',
}

export const INIT_FORM_EXTRAS = {
  primaryDoctorInfo: '',
  medicinesNeeded: '',
  infoExtra: '',
  extraNotesComments: '',
  cancellationDate: '',
  specialEnrollmentDate: '',
  specialEnrollmentReason: '',
}

export const INIT_FORMS_PAYMENTS = {
  recurrentPayment: false,
  typeCard: '',
  cardCompany: '',
  cardNumber: '',
  expirationMonth: '',
  expirationDay: '',
  cvvCsv: '',
  firstPaymentDate: '',
  bankAccount: false,
  bankName: '',
  ABARouting: '',
  accountNumber: '',
  preferredPayment: '',
  billingAddress: false,
  paymentHolder: '',
  address1: '',
  address2: '',
  city: '',
  zipCode: '',
  stateEU: {id: '', code: '', name: ''},
}

export const INIT_FORM_MEMBERS = {
  preferredLenguage: '',
  applicant: true,
  rol: '',
  firstName: '',
  middleName: '',
  lastName: '',
  secondLastName: '',
  dateBirth: '',
  gender: '',
  emailAddress: '',
  phone: '',
  maritalStatus: '',
  relationship: '',
  countryBirth: '',
  weight: '',
  height: '',
  immigrationStatus: '',
  immigrationStatusCode: '',
  uscis: '',
  passport: '',
  ssn: '',
  ssnIssuedDate: '',
  greenCard: '',
  greenCardIssuedDate: '',
  greenCardExpirationDate: '',
  workPermitCard: '',
  workPermitIssuedDate: '',
  workPermitExpirationDate: '',
  driverLicense: '',
  driverLicenseExpirationDate: '',
  medicareNumber: '',
  medicarePartAStartDate: '',
  medicarePartBStartDate: '',
  employerName1: '',
  selfEmployed1: false,
  employerPhone1: '',
  positionOccupation1: '',
  annualIncome1: '',
  employerName2: '',
  selfEmployed2: false,
  employerPhone2: '',
  positionOccupation2: '',
  annualIncome2: '',
  employerName3: '',
  selfEmployed3: false,
  employerPhone3: '',
  positionOccupation3: '',
  annualIncome3: '',
  policy: '',
  id: '',
  usesTobacco: false,
  isPregnant: false,
  hasMec: false,
}

export const INIT_FORM_QUOTE_POLICY = {
  id: '',
  created: '',
  updated: '',
  policyName: '',
  state: 'PENDING',
  stateDocs: 'PENDING',
  paymentStatus: 'PENDING',
  FFM: '',
  NPN: '',
  typeSale: '',
  effectiveDate: '',
  marketplaceId: '',
  memberId: '',
  CMSPlanId: '',
  planName: '',
  policyTotalCost: '',
  taxCredit: '',
  premium: '',
  percentageValue: '',
  nominalValue: '',
  ownsCar: null,
  ownsHome: null,
  hasAutoPolicy: null,
  hasHomePolicy: null,
  hasCarrierAccount: false,
  accountUsername: '',
  accountPassword: '',
  status: '',
  completedDate: '',
  canceledDate: '',
  commissionPayable: false,
  zipCode: '',
  countyFips: '',
  address1: '',
  address2: '',
  city: '',
  stateEU: {id: '', code: '', name: ''},
  mailingAddress1: '',
  mailingAddress2: '',
  mailingCity: '',
  mailingZipCode: '',
  mailingCountyFips: '',
  mailingStateeu: {id: '', code: '', name: ''},
  stateName: '',
  isImportant: false,
  applicants: '',
  members: '',
  dependents: 0,
  metalLevel: 0,
  user: {id: ''},
  typePolicy: {id: ''},
  leadSource: {id: ''},
  carrier: {id: ''},
  policyAttachmentsSet: {...INIT_FORM_ATTACHMENTS},
  lead: {},
  assignedTo: {id: 0},
  holder: {...INIT_FORM_MEMBERS},
  policyMembers: [] as typeof INIT_FORM_MEMBERS[],
  policyPayment: {...INIT_FORMS_PAYMENTS},
  policyExtraInfo: {...INIT_FORM_EXTRAS},
  policyMembersDelete: [],
}
